import { Messages } from '~src/codegen/Localize';
import { openReactConfirmationDialog } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

export function openDeleteDomainConfirmationDialog(deleteDomain: () => void) {
    const dialogInstance = openReactConfirmationDialog({
        title: Messages.bridgeSiteSettingsDeleteDomain(),
        message: Messages.bridgeSiteSettingsDeleteDomainConfirmation(),
        paramsForAction: {},
        actionName: Messages.confirm(),
        action: () => {
            deleteDomain();
            return Promise.resolve();
        },
        isActionDelete: true,
        dialogWidth: TabDialogWidth.width375px
    });

    return Promise.resolve(dialogInstance.result);
}
